import { Flex } from '../Flex.js';
import { styled } from 'styled-components';
import { H1, P } from '../Typography.js';
import { Spinner } from '../Spinner.js';

const ViewContainer = styled(Flex).attrs((props) => {
  return {
    direction: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "elementsContainer",
    ...props
  };
}).withConfig({
  displayName: "EmptyState__ViewContainer",
  componentId: "sc-d48e4b96-0"
})([
  `height:100%;flex-grow:1;`
]);
const EmptyStateTextContainer = styled(Flex).attrs({
  direction: "column",
  alignItems: "center",
  justifyContent: "center"
}).withConfig({
  displayName: "EmptyState__EmptyStateTextContainer",
  componentId: "sc-d48e4b96-1"
})([
  `gap:1rem;transition-delay:600ms;transition:1s all;max-width:380px;`
]);
const EmptyStateTextTitle = styled(H1).withConfig({
  displayName: "EmptyState__EmptyStateTextTitle",
  componentId: "sc-d48e4b96-2"
})([
  `text-align:center;font-size:2rem;opacity:0.5;letter-spacing:-0.02em;`
]);
const EmptyStateTextDescription = styled(P).attrs({
  color: "tertiary",
  size: "sm"
}).withConfig({
  displayName: "EmptyState__EmptyStateTextDescription",
  componentId: "sc-d48e4b96-3"
})([
  `text-align:center;opacity:0.5;`
]);
const RivCanvas = styled.canvas.withConfig({
  displayName: "EmptyState__RivCanvas",
  componentId: "sc-d48e4b96-4"
})([
  `height:240px;width:240px;max-width:70vh;max-height:70vh;opacity:0;transition-delay:200ms;transition:1s opacity;`
]);
const EmptyStateSpinner = styled(Spinner).attrs({
  size: 32
}).withConfig({
  displayName: "EmptyState__EmptyStateSpinner",
  componentId: "sc-d48e4b96-5"
})([
  ``
]);
const EmptyState = {
  Description: EmptyStateTextDescription,
  Title: EmptyStateTextTitle,
  TextContainer: EmptyStateTextContainer,
  RivCanvas,
  ViewContainer,
  Spinner: EmptyStateSpinner,
  SpinnerContainer: styled.div.withConfig({
    displayName: "EmptyState__SpinnerContainer",
    componentId: "sc-d48e4b96-6"
  })([
    `margin:20vh 0;`
  ])
};

export { EmptyState };
//# sourceMappingURL=EmptyState.js.map
